import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { PackageService } from './package.service';
import { Package } from '../../interfaces/package/package.interface';
import { PackageSearchParam } from '../../interfaces/package/package-search-param.interface';
import { PageResponse } from '../../../../core/interfaces/page-response.interface';
import { HttpParams, HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class PackageApiService extends PackageService {
    private http = inject(HttpClient);

    private readonly ENDPOINT = '/packages';

    override findAll(searchParam: PackageSearchParam): Observable<PageResponse<Package>> {
        let params = new HttpParams();
        if (searchParam.page !== undefined) params = params.set('page', searchParam.page.toString());
        if (searchParam.size !== undefined) params = params.set('size', searchParam.size.toString());
        if (searchParam.searchTerm) params = params.set('search', searchParam.searchTerm);
        if (searchParam.category) params = params.set('category', searchParam.category);
        if (searchParam.status) params = params.set('status', searchParam.status);

        return this.wrapRequest(
            this.http.get<PageResponse<Package>>(this.ENDPOINT, { params }),
            false,
            'Failed to fetch packages'
        );
    }

    override find(id: string): Observable<Package> {
        return this.wrapRequest(
            this.http.get<Package>(`${this.ENDPOINT}/${id}`),
            false,
            'Failed to fetch package details'
        );
    }

    override create(data: Partial<Package>): Observable<Package> {
        return this.wrapRequest(
            this.http.post<Package>(this.ENDPOINT, data),
            false,
            'Failed to create package'
        );
    }

    override update(id: string, data: Partial<Package>): Observable<Package> {
        return this.wrapRequest(
            this.http.put<Package>(`${this.ENDPOINT}/${id}`, data),
            false,
            'Failed to update package'
        );
    }

    override delete(id: string): Observable<void> {
        return this.wrapRequest(
            this.http.delete<void>(`${this.ENDPOINT}/${id}`),
            false,
            'Failed to delete package'
        );
    }
}
